import { Link } from "react-router-dom";

function Computerlab() {
  return (
    <>
      <div className="innerslide py-3 bg-light border-bottom">
        <ul className="breadcrumb container mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item"> Facilities</li>
          <li className="breadcrumb-item active"> Infirmary</li>
        </ul>
      </div>
      <div className="innersec container my-5">
        <div className="row g-3 facilities_section_imgs">
          <div class="col-lg-12">
            <h1> Infirmary </h1>
            <p>
              An infirmary provides essential first aid and health care support
              within the school, offering a safe space where students can
              receive immediate medical attention, rest, and monitoring for
              minor injuries or illnesses, while ensuring overall well-being
              through regular health checks and prompt response to emergencies.
            </p>
          </div>
        </div>
        <br />
      </div>
    </>
  );
}
export default Computerlab;
